import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import {
    catchError,
    concatMap,
    map,
    mergeMap,
    takeUntil,
} from 'rxjs/operators';

import { listDataObservable } from '../scorecard/list-data';
import { Dependencies } from '../store';
import { PayloadAction } from '../store.model';

import {
    ActionType,
    ListData,
    ListDataResult,
    listDataResult,
    Reload,
    ReloadResult,
    reloadResult,
} from './my-scorecard.action';
import { retrieveBoxesObservable } from './retrieve-boxes';

const reload = (
    action: ActionsObservable<PayloadAction<ActionType, Reload>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<PayloadAction<ActionType, ReloadResult>> =>
    action.pipe(
        ofType(ActionType.SCORECARD_CARD__RELOAD),
        mergeMap((act) => {
            return of(null).pipe(
                concatMap(() => {
                    return retrieveBoxesObservable(
                        deps,
                        act.payload.periodTypes != null
                            ? act.payload.periodTypes
                            : [null],
                        act.payload.user.id,
                        null,
                        null,
                        null,
                        null,
                    );
                }),
                map((ret) =>
                    reloadResult(
                        { ...act.payload, scorecardBoxes: ret },
                        act.storePath,
                    ),
                ),
                catchError((err) => {
                    console.log(err);
                    return of(reloadResult({ ...act.payload }, act.storePath));
                }),
                // takeUntil(action.pipe(
                //     ofType(ActionType.SCORECARD_CARD__RELOAD_CANCEL)
                // ))
            );
        }),
    );

export const listData = (
    action: ActionsObservable<PayloadAction<ActionType, ListData>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<PayloadAction<ActionType, ListDataResult>> =>
    action.pipe(
        ofType(ActionType.SCORECARD_CARD__LIST_DATA),
        mergeMap((act) => {
            return of(null).pipe(
                concatMap(() => {
                    return listDataObservable(
                        deps,
                        act.payload.scorecardIds,
                        null,
                    );
                }),
                map((ret) =>
                    listDataResult(
                        { ...act.payload, scorecardData: ret },
                        act.storePath,
                    ),
                ),
                catchError((err) => {
                    console.log(err);
                    return of(
                        listDataResult({ ...act.payload }, act.storePath),
                    );
                }),
                takeUntil(
                    action.pipe(
                        ofType(ActionType.SCORECARD_CARD__LIST_DATA_CANCEL),
                    ),
                ),
            );
        }),
    );

export const scorecardEpics = [reload, listData];
